/* eslint-disable @typescript-eslint/ban-ts-comment */

import clsx from 'clsx'
import { useTypoStyles } from '../Utile'
import { ExtenedTypographyProps } from '../Type'
import { LabelSeparatorStyle } from './Styles'

/* --------------------------------- LABEL SEPARATOR --------------------------------- */

export const LabelSeparator: React.FC<ExtenedTypographyProps> = ({
  className,
  children,
  fontColor,
  ...props
}): React.ReactElement => {
  const classes = useTypoStyles({
    fontColor,
    ...props,
  })
  return (
    <LabelSeparatorStyle
      // @ts-ignore
      component="p"
      className={clsx(className, classes.color)}
      {...props}
    >
      {children}
    </LabelSeparatorStyle>
  )
}
